import { Injectable } from '@angular/core';
import * as firebase from 'firebase/app';
import { CERT } from '../../certs/nhaphangorder-cert';

@Injectable({
  providedIn: 'root'
})
export class UserService {
  public nhaphangorderApp: firebase.app.App;

  constructor() {
    if (!firebase.apps.some(app => app.name === 'NhaphangorderApp')) {
      this.nhaphangorderApp = firebase.initializeApp(CERT, 'NhaphangorderApp');
    } else {
      this.nhaphangorderApp = firebase.app('NhaphangorderApp');
    }
  }
}
